import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import "firebase/auth";
import "firebase/firestore";
import "firebase/functions";
const firebaseConfig = {
  apiKey: "AIzaSyBasCdmPmTv9UuYyfvFH2ZLOViS5Ul3Nq8",
  authDomain: "gardening-9ccf8.firebaseapp.com",
  projectId: "gardening-9ccf8",
  storageBucket: "gardening-9ccf8.appspot.com",
  messagingSenderId: "22130986770",
  appId: "1:22130986770:web:3ba6489a5a85e98ee5adcb",
};
export const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);
